import { render } from "./혈액종양내과.vue?vue&type=template&id=2a2bb2be"
import script from "./혈액종양내과.vue?vue&type=script&lang=js"
export * from "./혈액종양내과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__